import { useRouteError } from "react-router-dom";

export default function ErrorPage() {
    const error = useRouteError();
    console.log(error);
    
    return (
        <div id="error-page">
            <h1>Oops!</h1>
            <p>
                Sorry, an unexpected error occurred.
            </p>
            <p>
                { error ? (
                    <i>{  error.statusText || error.message }</i>
                ) : (
                    <i>Page not found: { location.pathname }</i>
                )}
            </p>
        </div>
    );
}